import * as types from "../ActionType";
import axios from "axios";
import { notifyError, notifysuccess } from "../../components/general/Notification";
import { hasExpirition, hasExpiritionWithLoad } from "../../components/general/general-component/abstruct-component/useExpirition";
const END_POINT = process.env.REACT_APP_BASE_URL;

const get = (arr, type) => {
    return ({
        type: type,
        payload: arr
    })
}
const add = (type) => {
    return ({
        type: type
    })
}
const delelte = (type) => {
    return ({
        type: type
    })
}
const edit = (type) => {
    return ({
        type: type
    })
}


export const loadCreativeWork = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${END_POINT}/api/creative-works`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status == "Success") {
                dispatch(get(res.data.data, types.GET_CREATIVE_WORK));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data.message)
        })
    }
}

export const filterCreativeWork = (status, date_from, date_to, creative_work_type_id, visitor_id, setLoad) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA")
        setLoad(true);
        const queryParams = [];
        if (status !== '') queryParams.push(`filters[status]=${status}`);
        if (date_from !== '') queryParams.push(`filters[date_from]=${date_from}`);
        if (date_to !== '') queryParams.push(`filters[date_to]=${date_to}`);
        if (creative_work_type_id !== null) queryParams.push(`filters[creative_work_type_id]=${creative_work_type_id}`);
        if (visitor_id !== null) queryParams.push(`filters[visitor_id]=${visitor_id}`);
        const finalQuery = queryParams.join('&');
        const apiUrl = `${END_POINT}/api/creative-works?${finalQuery}`;
        console.log(apiUrl);
        axios.get(apiUrl, {
            headers: {
                "Authorization": `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            setLoad(false);
            dispatch(get(res.data.data, types.GET_CREATIVE_WORK));
        }).catch((err) => {
            console.log(err);
            setLoad(false);
        });
    };
};

export const postCreativeWorkStatus = (creativeWorkId, status , message = '') => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.put(`${END_POINT}/api/creative-works/change-status/${creativeWorkId}`, { status , message }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            if (res.data.status === "Success") {
                dispatch(loadCreativeWork());
                notifysuccess(res.data.message)
            }
        }).catch((err) => {
            notifyError(err.response.data.message)
        })
    }
}

